import { useTranslation } from "react-i18next";
import StatusMessage from "../../../ui/feedback/StatusMessage";
import type { RowHint } from "./artifactTables";

/** The table editors' row checks, as hints: the server checks the format, curators the rest. */
export default function RowHints({ hints }: { hints: readonly RowHint[] }) {
  const { t } = useTranslation();
  if (hints.length === 0) {
    return null;
  }
  return (
    <StatusMessage tone="info" className="px-2 py-1 text-xs">
      <ul className="space-y-0.5" aria-label={t("authoring.artifact.hints.title")}>
        {hints.map((hint, index) => (
          <li key={index}>
            {hint.kind === "labelsWithoutTerm" ? t("authoring.artifact.hints.labelsWithoutTerm", { labels: hint.labels.join(", ") }) : null}
            {hint.kind === "emptyKey" ? t("authoring.artifact.hints.emptyKey", { row: hint.row }) : null}
            {hint.kind === "duplicateKey" ? t("authoring.artifact.hints.duplicateKey", { key: hint.key }) : null}
            {hint.kind === "unknownLabel" ? t("authoring.artifact.hints.unknownLabel", { key: hint.key, label: hint.label }) : null}
            {hint.kind === "noLabel" ? t("authoring.artifact.hints.noLabel", { key: hint.key }) : null}
          </li>
        ))}
      </ul>
    </StatusMessage>
  );
}
